<template>
  <div>
    <productBanner />
    <div class="content">
      <div class="ins">
        <div class="title">企业综合质量管理系统</div>
        <div
          class="desc"
        >企业综合质量管理系统主要面向药品生产企业的质量体系管理、质量数据运营和分析的质量信息化业务系统，系统以企业现有质量业务模块为基础，帮助企业打造连贯整个业务流和管理体系的综合质量数据和业务平台，并以此为基础提供了丰富的、合规的质量管理业务模块，帮助企业实现综合管理信息化。</div>
        <div>
          <p class="service">服务</p>
          <p class="fun">企业综合质量管理系统的功能模块有：</p>
          <img src="./images/img.png" alt />
        </div>
      </div>
      <div class="img-container">
        <img src="~assets/images/products/product3.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import productBanner from "components/product-banner";
export default {
  components: {
    productBanner
  }
};
</script>

<style lang="stylus" scoped>
.content
  padding 80px 9%
  display flex
  .ins
    flex 1
    display flex
    flex-direction column
    justify-content space-between
    .title
      color #0160B7
      font-size 30px
    .desc
      line-height 1.5
      font-size 14px
      color #333333
    img
      width 100%
      margin-top 10px
  .service
    font-size 18px
    color #333333
    margin-bottom 10px
  .fun
    color #666666
    font-size 14px
  .list
    display flex
    justify-content space-between
    margin-top 22px
    .item
      line-height 58px
      width 32%
      font-size 14px
      text-align center
      border 1px dashed #287BFF
      background rgba(240, 246, 255, 1)
  .img-container
    flex 1
    img
      width 95%
      margin-left 5%
</style>



// WEBPACK FOOTER //
// src/pages/qyzh/qyzh.vue